import { Textarea } from "@/components/ui/textarea";
import type { AutomationStep } from "@/types/Automation";
import type { StepNodeData } from "../types";
import { useDebouncedSyncedString } from "../useDebouncedSyncedString";
import { calculateSMSSegments, getMaxCharsForSegments } from "../utils";

export function SmsStepBody({
  step,
  onStepDataChange,
}: {
  step: AutomationStep;
  onStepDataChange: StepNodeData["onStepDataChange"];
}) {
  const { draft, onChange, onBlur, onFocus } = useDebouncedSyncedString({
    syncKey: step.id,
    externalValue: step.data?.body || "",
    onCommit: ({ value }) => onStepDataChange({ stepId: step.id, field: "body", value }),
  });
  const segments = calculateSMSSegments(draft);
  const maxChars = getMaxCharsForSegments({ message: draft, segments });

  return (
    <div className="p-4 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <Textarea
        placeholder="Enter SMS message body..."
        value={draft}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        className="min-h-20 text-sm nodrag"
      />
      <div className="flex justify-between items-center text-xs text-muted-foreground mt-1.5">
        <div>
          {draft.length} / {maxChars}
        </div>
        <div>
          {segments} segment{segments !== 1 ? "s" : ""}
        </div>
      </div>
    </div>
  );
}
